import {
  type AdmissionDto,
  type CustomerDto,
  type CustomerProfile,
  type ProfileAdmission,
} from '@/types';
import toAddress from '@/api/sirta/adapters/customerPage/addressAdapter';

/**
 * Création un objet "customer" depuis la réponse reçue du backend
 */
export const toCustomerProfile = (customerDto: CustomerDto): CustomerProfile => {
  return {
    fullName: customerDto.fullName,
    firstName: customerDto.firstName,
    lastName: customerDto.lastName,
    fileNumber: customerDto.fileNumber.toString(),
    admission: toCustomerProfileAdmission(customerDto.admission),
    areAddressesRestricted: customerDto.areAddressesRestricted,
    homeAddress: customerDto.homeAddress ? toAddress(customerDto.homeAddress) : null,
    homePhone: customerDto.homePhone,
    cellPhone: customerDto.cellPhone,
    email: customerDto.emailAddress,
    assistiveDevices: customerDto.assistiveDevices,
    bookingCompanionsAllowed: customerDto.isCompanionshipPossibleInBookingPeriod,
    otherEmailAddresses: customerDto.otherEmailAddresses,
    isLavalCustomer: customerDto.isLavalCustomer,
    isBookingAllowed: customerDto.isBookingAllowed,
    administrativeNote: customerDto.administrativeNote ?? null,
    disability: customerDto.disabilityType ?? null,
  };
};

function toCustomerProfileAdmission(admissionDto: AdmissionDto): ProfileAdmission {
  const profileAdmission: ProfileAdmission = {
    type: admissionDto.type,
    status: admissionDto.status,
    description: '',
    expiration: null,
    startDateOrTime: '',
    endDateOrTime: '',
    companionType: admissionDto.companionType,
  };

  switch (admissionDto.type) {
    case 'temporary': {
      if (admissionDto.expiration) {
        profileAdmission.expiration = {
          status: admissionDto.expiration,
          date: admissionDto.serviceEndDate,
        };
      }
      profileAdmission.startDateOrTime = admissionDto.serviceStartDate;
      profileAdmission.endDateOrTime = admissionDto.serviceEndDate;
      break;
    }

    case 'seasonal': {
      if (admissionDto.expiration) {
        profileAdmission.expiration = {
          status: admissionDto.expiration.type,
          date: admissionDto.expiration.type === 'near' ? admissionDto.expiration.date : '',
        };
      }
      profileAdmission.startDateOrTime = admissionDto.seasonStartDate;
      profileAdmission.endDateOrTime = admissionDto.seasonEndDate;
      break;
    }

    case 'evening': {
      profileAdmission.startDateOrTime = admissionDto.serviceStartTime;
      profileAdmission.endDateOrTime = admissionDto.serviceEndTime;
      break;
    }
  }

  return profileAdmission;
}
